import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {BankFiles} from "../interface/bankFiles";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BankFilesService {
  private readonly bankFilesListSubject: ReplaySubject<CountedAndPaginated<BankFiles>> = new ReplaySubject<CountedAndPaginated<BankFiles>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/bank-files?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<BankFiles>) => {
        this.bankFilesListSubject.next(result);
      });
  }

  public downloadImportFile(uuid: string): void {
    this.document.location.href = `/rest/crm/bank-files/${uuid}/downloadFile`;
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/bank-files/${uuid}`)
      .pipe(first());
  }

  public getBankFilesListSubject(): ReplaySubject<CountedAndPaginated<BankFiles>> {
    return this.bankFilesListSubject;
  }
}
